import { LABEL } from "./types";

export const PREMIUM_PLAN_ROUTE = "/checkout?plan_id=sc-usd-1m-paid_premium-24.95";

export enum PREFERRED_VOICE_ACTIONS {
  Play = "play",
  Stop = "stop",
  Rate_Modal = "rate_modal",
  Set_Conversation_Voice_Id = "set_conversation_voice_id",
  Get_Voices = "get_voices",
  Set_VoiceId = "set_voice_id",
}
